import * as React from 'react';
import { FlowType } from '../../../../services/userflow/UserFlowService';
import { OneTimeCodePage } from '../../pages/one-time-code/OneTimeCodePage';
import { ErrorFlow } from '../../pages/error/ErrorFlow';
import { ROUTES } from '../../../../Routes';
import PageConfig from '../../../../services/userflow/PageConfig';
import { navigateToErrorPageFromForgotPassword } from '../../pages/error/ErrorNavigation';
import { RouteComponentProps } from 'react-router-dom';

const config = {
  errorType: ErrorFlow.resetPassword,
  startRoute: ROUTES.RESET_PASSWORD_ENTER_USERNAME,
  analytics: { pageName: 'forgot-password-OTC', taskName: 'forgot-password-new' },
} as PageConfig;

const ForgotPasswordOneTimeCodePage: React.FC<RouteComponentProps> = (props) => (
  <OneTimeCodePage
    {...props}
    flow={FlowType.resetPassword}
    config={config}
    navigateToErrorPage={navigateToErrorPageFromForgotPassword(props.history)}
  />
);

export { ForgotPasswordOneTimeCodePage };
